module.exports = __webpack_public_path__ + "static/img/detail_trackField_02.24a2597.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/track-and-field-banner-campaign/detail_trackField_02.jpg
// module id = 291
// module chunks = 2